import React, {useMemo} from "react";
import {useTeamCandidateScope} from "./TeamCandidateScopeProvider";

const TeamConfirmPayoutForm = ({buttonClass = 'btn-primary',...props}) => {

    const {
        team,
        isLoading,
        isDisabled,
        updateTeamScope
    } = useTeamCandidateScope();

    const acceptPayoutBtnClass = useMemo(() => {
        return TB.mapClass("btn text-xs py-1 px-1.5 self-center whitespace-nowrap", {
            [buttonClass]: true,
            "disabled-edit-link": team.canAcceptPayout()
        })
    }, [team, isDisabled]);

    const updatePayout = async () => {
        if (isDisabled) {
            return
        }

        let updates = {payout_confirmed_at: team.hasConfirmedPayout() ? null : new Date()};

        if (!team.canAcceptPayout()) {
            await TB.alert('warning', 'Team Members Still Pending',
                'There are team members who haven\'t accepted their scope. All team members must accept their payout before you can confirm the team\'s payout', [
                {title: 'Ok'},
            ]);

            return;
        }
        if (team.total_proposed_talent_opps > 0) {

            let confirm = await TB.alert('warning', 'Team Members have Proposed Payouts',
                'There are team members who have proposed different payouts that what was scoped. Are you sure you want to confirm payout and allow the team\'s proposal to be viewed by the client?', [
                    {title: 'Yes, Continue'},
                    {title: 'Cancel'},
                ]);
            if (!confirm) {
                return;
            }
        }
        return updateTeamScope(updates)
    };
    if (isLoading || !team) {
        return null
    }
    if (team.hasConfirmedPayout()) {
        return (
            <div className="flex flex-row items-center gap-0.5">
                <p className="text-xs py-1 px-1.5 self-center whitespace-nowrap flex flex-row items-center gap-1.5">
                    <i className="fas fa-check-circle text-success"/>
                    <span>Accepted</span>
                </p>
                {/*<button className="text-xxs py-1 px-1.5 self-center whitespace-nowrap btn-link btn-link-primary" disabled={isDisabled}*/}
                {/*        onClick={updatePayout}>*/}
                {/*    Undo*/}
                {/*</button>*/}
            </div>
        )
    }

    return (
            <button className={acceptPayoutBtnClass} disabled={isDisabled}
                    onClick={updatePayout}>
                Accept Payout
            </button>
    )
}

export default TeamConfirmPayoutForm